import React from 'react'
import styled from 'styled-components';
import { useMediaQuery } from '../../hooks/mediaquery';
import {b} from "../../styles/variables"
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {KeyboardArrowRight} from '@styled-icons/material-sharp/KeyboardArrowRight';
import {FoodBank as RestosIcon} from '@styled-icons/material-rounded/FoodBank';
import {Coffee} from '@styled-icons/boxicons-regular/Coffee';
import {Restaurant} from '@styled-icons/ionicons-sharp/Restaurant';
import {FoodTag} from '@styled-icons/boxicons-regular/FoodTag';
import {Cookie} from '@styled-icons/boxicons-regular/Cookie';

function Home() { 
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)
  const foodSource = "VEG"

  const categories = [
    {
      title: "By Restaurant",
      subtitle: "Browse by your favourite restaurant",
      icon: <RestosIcon size={36} />,
      color: "#F7707D",
      bgColor: "rgba(247, 112, 125, 0.1)",
      onClick: () => navigate('vendors')
    },
    {
      title: "Breakfast",
      subtitle: "Start your morning right",
      icon: <Coffee size={32} />,
      color: "#f59e0b",
      bgColor: "rgba(245, 158, 11, 0.1)",
      onClick: () => navigate('/fooddata/food_avail/1')
    },
    {
      title: "Lunch",
      subtitle: "Delicious midday meals",
      icon: <Restaurant size={30} />,
      color: "#3b82f6",
      bgColor: "rgba(59, 130, 246, 0.1)",
      onClick: () => navigate('/fooddata/food_avail/2')
    },
    {
      title: "Snacks",
      subtitle: "Quick bites & treats",
      icon: <Cookie size={32} />,
      color: "#8b5cf6",
      bgColor: "rgba(139, 92, 246, 0.1)",
      onClick: () => navigate('/fooddata/food_avail/3')
    },
    {
      title: "Vegetarian",
      subtitle: "Pure veg options only",
      icon: <FoodTag size={32} />,
      color: "#22c55e",
      bgColor: "rgba(34, 197, 94, 0.1)",
      onClick: () => navigate(`/fooddata/food_source/${foodSource}`)
    }
  ];

  return (
    <MainContainer>
      <HeroSection>
        <HeroContent>
          <WelcomeText>Welcome back, {auth?.creds?.username?.split(' ')[0]}</WelcomeText>
          <HeroTitle>What would you like to eat today?</HeroTitle>
          <HeroSubtitle>Order from your favourite restaurants and enjoy a great meal</HeroSubtitle>
          <BrowseAllButton onClick={() => navigate('/fooddata/foodall')}>
            Browse All Food <KeyboardArrowRight size={22} />
          </BrowseAllButton>
        </HeroContent>
        <HeroGraphic>
          <EmojiCircle>
            <span role="img" aria-label="food">&#127869;</span>
          </EmojiCircle>
        </HeroGraphic>
      </HeroSection>

      <SectionTitle>Quick Categories</SectionTitle>
      <CardsGrid>
        {categories.map((cat, i) => (
          <CategoryCard key={i} onClick={cat.onClick}>
            <CardIconWrapper style={{ background: cat.bgColor, color: cat.color }}>
              {cat.icon}
            </CardIconWrapper>
            <CardContent>
              <CardTitle>{cat.title}</CardTitle>
              <CardSubtitle>{cat.subtitle}</CardSubtitle>
            </CardContent>
            <CardArrow>
              <KeyboardArrowRight size={24} />
            </CardArrow>
          </CategoryCard>
        ))}
      </CardsGrid>
    </MainContainer>
  )
}

export default Home

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 2.4rem;
  overflow-y: auto;

  @media ${b.mobile}{
    padding: 1.6rem;
  }
`

const HeroSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #1e1e2d 0%, #2d2d44 100%);
  border-radius: 20px;
  padding: 3.6rem 4rem;
  margin-bottom: 3rem;
  overflow: hidden;
  position: relative;

  @media ${b.mobile}{
    flex-direction: column;
    padding: 2.4rem 2rem;
    text-align: center;
  }
`

const HeroContent = styled.div`
  flex: 1;
  z-index: 1;
`

const WelcomeText = styled.span`
  font-size: 1.3rem;
  color: #F7707D;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow-wrap: break-word;
  word-break: break-word;
`

const HeroTitle = styled.h1`
  font-size: 3.2rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0.8rem 0;
  line-height: 1.2;

  @media ${b.mobile}{
    font-size: 2.4rem;
  }
`

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 2rem;
  font-weight: 300;
`

const BrowseAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1.2rem 2.4rem;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(247, 112, 125, 0.35);
  }

  &:active {
    transform: translateY(0);
  }
`

const HeroGraphic = styled.div`
  flex-shrink: 0;
  margin-left: 3rem;

  @media ${b.mobile}{
    margin-left: 0;
    margin-top: 2rem;
  }
`

const EmojiCircle = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 5rem;
  }

  @media ${b.mobile}{
    width: 80px;
    height: 80px;
    span { font-size: 3.5rem; }
  }
`

const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #1e1e2d;
  margin-bottom: 1.6rem;
`

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.6rem;
  padding-bottom: 3rem;

  @media ${b.mobile}{
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
`

const CategoryCard = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #f4f4f5;
  border-radius: 16px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.25s ease;
  -webkit-tap-highlight-color: transparent;
  min-height: 44px;

  &:hover, &:active {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    border-color: transparent;
  }

  &:active {
    transform: translateY(-1px);
  }
`

const CardIconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const CardContent = styled.div`
  flex: 1;
  margin-left: 1.6rem;
`

const CardTitle = styled.h3`
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e1e2d;
  margin-bottom: 0.2rem;
`

const CardSubtitle = styled.p`
  font-size: 1.2rem;
  color: #71717a;
  font-weight: 400;
`

const CardArrow = styled.div`
  color: #d4d4d8;
  flex-shrink: 0;
  transition: all 0.2s ease;
  
  ${CategoryCard}:hover & {
    color: #F7707D;
    transform: translateX(4px);
  }
`
